import React from 'react';
import { Link } from "react-router-dom";

import { MailLink } from "./index";
import Section from "./Section";
import ContactUsButton from "../Button/ContactUsButton";

export default class QuestionSection extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {

        return (
            <Section>
                <p className={"bmw-condenced-bold text-2xl"}>
                    QUESTIONS?
                </p>
                <p className={"bmw-condenced-bold text-sm pb-4"}>
                    If you have any questions please visit the
                    {" "}
                    <Link to="/faq" className="underline">
                        FAQs
                    </Link>
                    {" "}
                    page
                </p>
            </Section>
        )
    };
}
